import { useState } from "react";
import { toggleKey } from "./rowState";

/** Which rows are opened, by row key. */
export interface ExpandedRows {
  isOpen: (key: string) => boolean;
  toggle: (key: string) => void;
}

export function useExpandedRows(): ExpandedRows {
  const [expanded, setExpanded] = useState<ReadonlySet<string>>(new Set());
  return {
    isOpen: (key) => expanded.has(key),
    toggle: (key) => setExpanded((current) => toggleKey(current, key)),
  };
}
